"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerExternalAppAccessStatus = void 0;
var CustomerExternalAppAccessStatus;
(function (CustomerExternalAppAccessStatus) {
    CustomerExternalAppAccessStatus["ACTIVE"] = "active";
    CustomerExternalAppAccessStatus["INACTIVE"] = "inactive";
    CustomerExternalAppAccessStatus["PENDING"] = "pending";
})(CustomerExternalAppAccessStatus = exports.CustomerExternalAppAccessStatus || (exports.CustomerExternalAppAccessStatus = {}));
